import { render, staticRenderFns } from "./liucheng.vue?vue&type=template&id=5691fcda&scoped=true"
import script from "./liucheng.vue?vue&type=script&lang=js"
export * from "./liucheng.vue?vue&type=script&lang=js"
import style0 from "./liucheng.vue?vue&type=style&index=0&id=5691fcda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5691fcda",
  null
  
)

export default component.exports